import { props } from '@ngrx/store';
import { CxbActionTriplet } from '../core/cxb-action-triplet';
import { RedirectPolicy } from '../domain/redirect-policy';

const feature = '[Redirect policies]';

export const fetchRedirectPolicies = CxbActionTriplet.withSuccessProps(
  `${feature} Fetch redirect policies`,
  props<{ policies: RedirectPolicy[] }>()
);

export const createRedirectPolicy = CxbActionTriplet.withSourceAndSuccessProps(
  `${feature} Create redirect policy`,
  props<{ policy: RedirectPolicy }>(),
  props<{ policies: RedirectPolicy[] }>()
);

export const updateRedirectPolicy = CxbActionTriplet.withSourceAndSuccessProps(
  `${feature} Update redirect policy`,
  props<{ policy: RedirectPolicy }>(),
  props<{ policies: RedirectPolicy[] }>()
);

export const deleteRedirectPolicy = CxbActionTriplet.withSourceAndSuccessProps(
  `${feature} Delete redirect policy`,
  props<{ policyId: string }>(),
  props<{ policies: RedirectPolicy[] }>()
);
